<div class="grid-container margin-top">
    <ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="reportData" (firstDataRendered)="onGridPageChanged($event)" aria-label="Letters Of Credit Report"></ag-grid-angular>
</div>